import useElectronHook from "./useElectronHook";
import usePrinterSettingsHook from "./usePrinterSettingsHook";

const useOpenCashDrawerHook = () => {
  const { getPrinterSettings } = usePrinterSettingsHook();
  const { isElectron } = useElectronHook();

  if (!isElectron) {
    return () => null;
  }

  return () =>
    window?.api?.send(
      "openCashDrawer",
      getPrinterSettings?.data?.chosenPrinters ?? null,
    );
};

export default useOpenCashDrawerHook;
